module.exports = __webpack_public_path__ + "images/132_4096.jpg";